const e=async(e,t,n)=>{let{data:r}=await e.get(`/apps/${t}/email-template/${n}`);return r};export{e as getEmailTemplate};
//# sourceMappingURL=get-email-template.mjs.map